import { setWithinRange } from "@@/utilities/set-within-range";
import type { DateAgnosticTime } from "./date-agnostic-time";

function createDateAgnosticTime(
    time: string,
    defaults?: DateAgnosticTime
): DateAgnosticTime | undefined;
function createDateAgnosticTime(
    time: { hour: string; minute: string },
    defaults?: DateAgnosticTime
): DateAgnosticTime | undefined;
function createDateAgnosticTime(
    time: { hour: number; minute: number },
    defaults?: DateAgnosticTime
): DateAgnosticTime;
function createDateAgnosticTime(
    time:
        | { hour: number; minute: number }
        | { hour: string; minute: string }
        | string
): DateAgnosticTime | undefined {
    const timeStringToHourMinute = (input: string) => {
        const hourMinute = input.replace(/\s+/g, "").split(":");
        const hour = hourMinute[0];
        const minute = hourMinute[1];
        return {
            hour,
            minute,
        };
    };

    const _time =
        typeof time === "string" ? timeStringToHourMinute(time) : time;

    const hour = setWithinRange(
        typeof _time.hour === "number" ? _time.hour : Number(_time.hour),
        { min: 0, max: 23 }
    );

    const minute =
        setWithinRange(
            typeof _time.minute === "number"
                ? _time.minute
                : Number(_time.minute),
            { min: 0, max: 59 }
        ) || 0;

    const isComplete = typeof hour === "number" && typeof minute === "number";

    return isComplete
        ? {
              hour,
              minute,
          }
        : undefined;
}

export { createDateAgnosticTime };
